module.exports = __webpack_public_path__ + "static/bi-mobile-screen1-9b1878a7816226da968488c2b00a59da.jpeg";